import {
  ActivitiesFiltersCard,
  ActivitiesMetricsDashboard,
  ActivitiesTableCard,
  useReconActivitiesPage,
} from '@ovComponents/4-module/reconActivities';
import { usePermission } from '@providers/userContextProvider';
import { Box, Typography, useTheme } from 'hephaestus/web';

const ReconActivitiesPage = () => {
  const theme = useTheme();
  const canReadCustodianActivityBasic = usePermission(
    'read:custodian_activity_basic',
  );
  const { t, metrics, filtersProps, gridProps } = useReconActivitiesPage(
    canReadCustodianActivityBasic,
    theme,
  );

  if (!canReadCustodianActivityBasic) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      }}
    >
      <Box>
        <Typography variant='bodyMedium' color='textSecondary'>
          {t('activitiesV3.pageSubtitle')}
        </Typography>
      </Box>
      <ActivitiesMetricsDashboard
        tiles={metrics.tiles}
        loading={metrics.loading}
        hasData={metrics.hasData}
        error={metrics.error}
      />
      <ActivitiesFiltersCard {...filtersProps} />
      <ActivitiesTableCard {...gridProps} />
    </Box>
  );
};

export default ReconActivitiesPage;
